<template>
    <div><slot></slot></div>
</template>
<script>

import Store from '@/stores/store.js'
import Bus from '@/bus/BusEvent.js'
import Raf from '@/utils/raf.js'
import GL from '@/views/GL/GL.js'
import ThreeScroll from '@/utils/ThreeScroll'
import ControllerGUI from '@/utils/ControllerGUI'

export default {
    name: 'GroupGL',

    props: {
        top: { type: Number, default: 0 },
        left: { type: Number, default: 0 },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 },
        scale: { type: Number, default: 1 },
        visible:  { type: Boolean, default: true },
        name: { type: String, default: '' },
        hasScroll:  { type: Boolean, default: false },
    },

    data() {
        return {
            transition: [Power3.easeIn, Power3.easeOut, Power3.easeInOut, Linear.easeInOut]
        }
    },

    created(){        
        this.scroll = null;
        this.inc = 0;
        this.group = new THREE.Object3D();
        this.group.visible = this.visible;
        this.scaleO = { val: this.scale }

        this._onScaleUpdate = this.onScaleUpdate.bind(this);
    },

    methods: {
        onScaleUpdate(){
            /**
             * Updates the groups scale on transition
             */
            this.group.scale.setScalar( this.scaleO.val );
        },

        setScale(){
            /**
             * Triggered by parent when entenring transition, takes scale from max to normal values 
             */
            TweenMax.to(this.scaleO, Store.state.level == 2 ? ControllerGUI.Menu.scaleDuration/2 : ControllerGUI.Menu.scaleDuration, {val: this.scale, onUpdate: this._onScaleUpdate, ease: this.transition[ControllerGUI.Menu.transition_scale] });
        },

        setPosition(){
            /**
             * Position groups from the middle 
             */
            this.group.position.x = this.left - (Store.width/2) + this.x;
            this.group.position.y = this.top - (Store.height/2) + this.y;
            this.group.pivot = new THREE.Vector3( 0, this.vw(20), 0 );
        },

        addScroll(){
            /**
             * Add custom ThreeScroll if true, bottom margins are magic numbers
             */
            if(Store.isDesktop) {
                this.scroll = new ThreeScroll(this.group, {
                    top: 0,
                    bottom: Store.height/100 * 15
                }, this.name)
            }
            else {
                this.scroll = new ThreeScroll(this.group, {
                    top: 0,
                    bottom: Store.height/100 * 20
                }, this.name)
            }
        },

        resetScroll() {
            /**
             * Resets scroll, called by parents when scrolled container not visible
             */
            this.scroll.resetScroll()
        },

        enableScroll() {
            /**
             * Blocks scroll by route if scroll not visible, takes name parameter to match with route (if name = news and path = /news/)
             */
            if(this.hasScroll) {
                if(this.$route.path.includes(this.name) || this.name === 'NotFound') {
                    
                    this.scroll.enable()
                }
                else {
                    this.scroll.disable()
                }
            }
        }
    },

    mounted(){
        /**
         * Inits children meshes 
         */
        for (let index = 0; index < this.$children.length; index++) {
            if(!this.$children[index].group)
                this.group.add(this.$children[index].textGL.mesh);
            else {
                this.group.add(this.$children[index].group);
            }
        }
        /**
         * Sets initial scale values
         */
        this.group.scale.setScalar(this.scaleO.val)
        this.setPosition();
        
        if(this.hasScroll){
            this.addScroll();
            GL.addGroupGL(this.scroll.anchor);
        }else{
            GL.addGroupGL(this.group);
        }

        setTimeout(() => {
            /**
             * timeout on scroll else not init
             */
            this.enableScroll()
        }, 1000);


    },

    watch: {
        scale: function(newVal, oldVal){
            if(oldVal == 0.35 && this.$route.path.includes('directors')) {
                setTimeout(() => {
                    this.setScale();
                }, 200);
            }
            else this.setScale();
        },
        top: function(){
            this.setPosition()
        },
        left: function(){
            this.setPosition()
        },
        visible: function () {
            this.group.visible = this.visible;
        },
        x: function(){
            this.setPosition()
        },
        $route (to, from){
            this.enableScroll()
        }
    }
}
</script>